import Vue from "vue";
import useNotify from "@Composables/useNotify";

function team({ to, next, store, nextMiddleware }) {
  const { notifyError } = useNotify();

  if (!to.params.teamId) {
    notifyError({ text: "Team required." });
    return next({ name: "settings.teams" });
  }

  const teamsIdentifiedByPath = Vue.Spark("teamsIdentifiedByPath");

  const targetTeam = _.find(store.getters.teams, (team) => {
    return teamsIdentifiedByPath
      ? team.slug === to.params.teamId
      : team.id === parseInt(to.params.teamId);
  });

  if (targetTeam === undefined) {
    notifyError({ text: "Unknown team." });
    return next({ name: "settings.teams" });
  }

  store
    .dispatch(
      "switchTeam",
      teamsIdentifiedByPath ? targetTeam.slug : targetTeam.id,
    )
    .then(() => {
      nextMiddleware();
    })
    .catch(() => {
      notifyError({ text: "Switching error." });
      next({ name: "settings.teams" });
    });
}

export default team;
